module.exports = __webpack_public_path__ + "static/media/likebutton.befe93b5.svg";